<template lang="pug">
.remove-profile-image
  .info_basic_title
    .title-left
    span {{ $t(`${BASE_TRANSLATION_PATH}.title`) }}
  .info_basic_content
    aiq-image.profile-img.thumbnail(:file="thumbnailFile" :key="thumbnailKey" :alt="$t(`${BASE_TRANSLATION_PATH}.title`)")
    .controls
      aiq-tooltip(effect="dark"
                  :show-after="1000"
                  :content="$t('global.view')")
        aiq-button.view-btn(link @click="isDialogOpen = true")
          font-awesome-icon(:icon="['fas', 'eye']")
      aiq-tooltip(effect="dark"
                    :show-after="1000"
                    :content="$t('global.delete')")
        aiq-button.delete-btn(link @click="handleBeforeDelete")
          font-awesome-icon(:icon="['fas', 'trash-can-xmark']")
    aiq-dialog(v-model="isDialogOpen"
              :open-delay="500"
              class="remove-profile-img-dialog")

      aiq-image.profile-img(:file="imgFile" :key="imgKey" :alt="$t(`${BASE_TRANSLATION_PATH}.title`)")
      template(v-slot:footer)
        .dialog-footer
          aiq-button(@click="isDialogOpen = false") {{ $t('global.cancel') }}
          aiq-button(type="danger"
                    @click="handleBeforeDelete") {{ $t('global.delete') }}
</template>

<script>
import get from 'lodash/get';
import pick from 'lodash/pick';
import { mapState } from 'vuex';
import { CUSTOMER_EVENT } from '@/constants/analytics';

export default {
  name: 'RemoveProfileImage',
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      BASE_TRANSLATION_PATH: 'conversation_tab.side_panel.customer_info_accordion.section.remove_profile_image',
      profileImage: null,
      isDialogOpen: false,
    };
  },
  mounted() {
    this.profileImage = this.customer.profile_image;
  },
  watch: {
    customer: {
      handler(newCustomer) {
        this.profileImage = newCustomer.profile_image;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      conversation: state => state.conversations.selected,
      agent: state => state.agent,
    }),
    thumbnailKey() {
      return get(this.profileImage, 'payload.thumbnail.url');
    },
    thumbnailFile() {
      return get(this.profileImage, 'payload.thumbnail');
    },
    imgKey() {
      return get(this.profileImage, 'payload.url');
    },
    imgFile() {
      return get(this.profileImage, 'payload');
    },
  },
  methods: {
    async handleBeforeDelete() {
      try {
        await this.$aiq.confirm({
          title: `${this.$t('global.delete')}?`,
          message: this.$t(`${this.BASE_TRANSLATION_PATH}.confirm_dialog_message`),
          confirmButtonText: this.$t('global.continue'),
          cancelButtonText: this.$t('global.cancel'),
        });
        await this.unsetProfileImage();
      } catch {
        // The dialog will close
      }
    },
    async unsetProfileImage() {
      try {
        const updatedCustomer = await this.$store.dispatch('conversations/updateCustomerProfileImage', [this.customer.id]);
        await this.$store.dispatch(
          'notifications/emitEventToSocket',
          {
            name: CUSTOMER_EVENT.UPDATED,
            payload: { customer: updatedCustomer },
          },
        );
        await this.$store.dispatch('messages/sendSystemMessage', {
          conversation: pick(this.conversation, ['id']),
          action: 'customer.profile_image.updated',
          content: `Profile Image deleted by agent ${get(this.agent, 'profile.fullName')}`,
        });
        this.isDialogOpen = false;
        this.$aiq.notify.success(this.$t(`${this.BASE_TRANSLATION_PATH}.success_removal_message`));
      } catch (error) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.failing_removal_message`));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.info_basic_title {
  font-size: 14px;
  font-weight: 600;
  font-family: 'Roboto';
}

.info_basic_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 5px;

  .controls {
    display: flex;
    gap: 5px;

    & > button {
      border: none;
      outline: none;

      &:hover, &:focus, &.selected {
        border: none;
        outline: none;
      }
    }

    .view-btn {
      &:hover, &:focus, &.selected {
        color: #152E53;
      }
    }

    .delete-btn {
      &:hover, &:focus, &.selected {
        color: red;
      }
    }
  }
}

.profile-img {
  width: 60%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  overflow: hidden;
  max-width: 400px;
  max-height: 400px;

  &.thumbnail {
    max-width: 30px;
    max-height: 30px;
  }
}

</style>

<style lang="scss">
.remove-profile-img-dialog {
  .el-dialog__header {
    background: transparent;
  }

  .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>